/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignUpWithFacebookContainer_auth = {
    readonly integrations: {
        readonly facebook: {
            readonly redirectURL: string;
        };
    };
    readonly " $refType": "SignUpWithFacebookContainer_auth";
};
export type SignUpWithFacebookContainer_auth$data = SignUpWithFacebookContainer_auth;
export type SignUpWithFacebookContainer_auth$key = {
    readonly " $data"?: SignUpWithFacebookContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignUpWithFacebookContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpWithFacebookContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacebookAuthIntegration",
                    "kind": "LinkedField",
                    "name": "facebook",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "redirectURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = '56c60b587232c802c66d82341c96b263';
export default node;
